(function($) {
    //jQuery.fn.dataTableExt.oSort['date-pre']
    $.fn.dataTableExt.oSort['czdate'] = function (a, b) {
        return a < b;
    };
    $.fn.dataTableExt.oSort['czdate-pre'] = function (value) {
        if (!value) {
            return value;
        }
        var i, date, time, parts;
        parts = value.split(' ');
        date = parts[0].split('-');

        if(parts[1] != null) {
            time = parts[1].split(':');
        } else {
            time = ['00', '00', '00'];
        }

        for (i = 0; i < date.length; i++) {
            date[i] = parseInt(date[i], 10);
        }
        for (i = 0; i < time.length; i++) {
            time[i] = parseInt(time[i], 10);
        }
        return new Date(date[2], date[1], date[0], time[0], time[1], time[2]);
    };
})(jQuery);
